import React, { useState } from "react";
import { useSelector } from "react-redux";

import CFOPanelUsers from "./CFOPanelUsers";
import CFOPanelPDSubscribers from "./CFOPanelPDSubscribers";
import CFOPanelPDOnboardList from "./CFOPanelPDOnboardList";
import PDGSTRegisterIndia from "../purpledoor/modules/registers/GSTRegisterIndia";
import PDTaxRegisterOverseas from "../purpledoor/modules/registers/TaxRegisterOverseas";

export default function CFOPanel() {
    const authState = useSelector((state) => state.authReducer);

    const userId = authState?.user?._id || null;
    const userCode = authState?.user?.think5whyscode || "";
    const userName = authState?.user?.name || "User";

    const [showDoor, setShowDoor] = useState(true);
    const [tab, setTab] = useState("FREELANCE");

    const go = (value) => setTab(value);

    const tabs = [
        ["USERS", "Users", "fa-laptop-code"],
        ["PDONBOARD", "PurpleDoor Onboarding", "fa-bolt"],
        ["PDSUBS", "PurpleDoor Subscriptions", "fa-globe"],
        ["PDGSTREG", "PurpleDoor GST Register", "fa-globe"],
        ["PDOVERSEASTAXREG", "PurpleDoor Overseas Tax Regsiter", "fa-globe"],
        // ["PDREVENUE", "PurpleDoor Partner Revenue", "fa-globe"],
    ];

    const renderContent = () => {
        switch (tab) {
            case "PDSUBS":
                return <CFOPanelPDSubscribers userId={userId} userCode={userCode} />;

            case "PDONBOARD":
                return <CFOPanelPDOnboardList userId={userId} />;

            case "PDONBOARD":
                return <PDGSTRegisterIndia taxMeta={null}/>;

            case "PDOVERSEASTAXREG":
                return <PDTaxRegisterOverseas taxMeta={null} />;

            // case "PDREVENUE":
            //     return <CFOPanelPDRevenue userId={userId} />;

            default:
                return <CFOPanelUsers hustleType={tab} userId={userId} />;
        }
    };     

    return (
        <div className="min-h-screen bg-[#0b0f19] text-white flex flex-col">
            <div className="sticky top-0 z-10 bg-[#111827] border-b border-gray-800 px-3 py-3">
                <div className="text-cyan-400 font-bold text-xs lg:text-sm">
                    💼 Think5Whys Admin CFO Panel
                </div>
                <div className="text-[10px] text-gray-400">
                    {userName} • {userCode}
                </div>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-5 bg-[#111827] border-b-2 border-cyan-200 rounded-xl px-1 gap-1 mb-2">
                {tabs.map(([id, label, icon]) => (
                    <button
                        key={id}
                        onClick={() => go(id)}
                        className={`flex flex-col items-center justify-center px-1 py-1 text-xs lg:text-sm transition-all duration-200 relative
                            ${
                                tab === id
                                    ? "text-cyan-400"
                                    : "text-gray-400"
                            }
                        `}
                    >
                        <i className={`fa ${icon} text-[13px] mb-[2px]`} />

                        <span className="text-[9px] leading-none whitespace-nowrap">
                            {label}
                        </span>
                        {tab === id && (
                            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-5 h-[2px] bg-cyan-400 rounded-full" />
                        )}
                    </button>
                ))}
            </div>
            <div className="flex-1 overflow-y-auto px-3 pb-4">
                {renderContent()}
            </div>
        </div>
    );
}